import {useEffect, useState} from 'react';

export function useGlobalTour() {
  const [globalSeen, setGlobalSeen] = useState(() => {
    return localStorage.getItem('globalTourSeen') === 'true';
  });

  const [runTour, setRunTour] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);

  useEffect(() => {
    if (!globalSeen) {
      setRunTour(true);
    }
  }, [globalSeen]);

  const markGlobalSeen = () => {
    localStorage.setItem('globalTourSeen', 'true');
    setGlobalSeen(true);
    setRunTour(false);
  };

  const handleJoyrideCallback = (data: any) => {
    const {status, index, type} = data;

    if (status === 'finished' || status === 'skipped') {
      markGlobalSeen();
    } else if (type === 'step:after') {
      setTourStepIndex(index + 1);
    }
  };

  return {
    runTour,
    tourStepIndex,
    handleJoyrideCallback,
    setRunTour,
  };
}
